// src/services/popupApi.js
import { API_URL } from '../config'

export async function getPopupConfig() {
  const res = await fetch(`${API_URL}/config/popup`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    credentials: 'include', // if cookies / session are needed
  })

  if (!res.ok) {
    throw new Error(`Failed to load popup config: ${res.status}`)
  }

  const data = await res.json()
  return data
}

// 🔹 new function — submit the answer to "How did you hear about us?"
export async function submitTrafficSource(answer) {
  const res = await fetch(`${API_URL}/config/traffic-sources`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ answer }),
  })

  if (!res.ok) {
    throw new Error(`Failed to submit traffic source: ${res.status}`)
  }

  return res.json()
}